<template>
  <div>
    <div class="main">
      <DataTablePage
        resource="waterMeter.json"
        title="水表管理"
        dialogSize="tiny"
        :relation="false"
        :toolbar="toolbar"
        :operation="operation"
        :autoIndex="false"
        :tableFullList="tableFullList"
        :tableInitList="tableInitList"
        :filterFullList="filterFullList"
        :filterInitList="filterInitList"
        :columns="columns"
        >
      </DataTablePage>
    </div>
    <el-dialog
      :title="mapTitle"
      v-model="showMap"
      :modal-append-to-body="false"
      >
      <div id="map"></div>
    </el-dialog>
  </div>
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { toolbarExport } from '@/containers/DataTablePage/toolbar'
import { expire } from '@/utils/auth'
// import AMap from 'AMap'
// import AMap from 'vue-amap'

export default {
  components: {
    DataTablePage
  },
  data () {
    const _this = this
    return {
      toolbar: [toolbarExport],
      tableInitList: ['bookNum', 'customNum', 'customName', 'phone', 'quality', 'address', 'date', 'code', 'outerCode', 'caliber', 'range', 'status'],
      tableFullList: ['bookNum', 'customNum', 'customName', 'phone', 'quality', 'address', 'date', 'code', 'outerCode', 'caliber', 'range', 'status'],
      filterInitList: ['customNum', 'quality', 'date'],
      filterFullList: ['customNum', 'quality', 'date'],
      operation: [{
        label: '地图',
        func (data) {
          _this.mapTitle = `【${data.customNum}】 地图`
          _this.showMap = true
          _this.$nextTick(() => {
            _this.addMap(data.address)
          })
        }
      }, {
        label: '抄表历史',
        func () {
          console.log(999)
        }
      }],
      columns: {
        bookNum: {
          label: '区本号',
          width: 85
        },
        customNum: {
          label: '户号',
          width: 72,
          filter: {
            type: 'input',
            like: true
          }
        },
        customName: {
          label: '户名',
          width: 80
        },
        phone: {
          label: '手机',
          width: 150
        },
        quality: {
          label: '用水性质',
          type: 'input',
          width: 100,
          filter: {
            type: 'input'
          }
        },
        address: {
          label: '地址'
        },
        date: {
          label: '换表日期',
          sort: true,
          width: 170,
          minLength: 20,
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss',
          filter: {
            type: 'daterange'
          }
        },
        code: {
          label: '条形码',
          width: 85
        },
        outerCode: {
          label: '行码',
          width: 70
        },
        caliber: {
          label: '口径',
          width: 70
        },
        range: {
          label: '量程',
          width: 70
        },
        status: {
          label: '服务状态'
        }
      },
      showMap: false,
      mapTitle: '',
      map: {}
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    addMap (data) {
      const _this = this
      this.map = new AMap.Map('map', {
        resizeEnable: true
      })
      this.map.plugin(['AMap.Geocoder'], () => {
        let geocoder = new AMap.Geocoder({
          city: '全国', // 城市，默认：“全国”
          radius: 1000 // 范围，默认：500
        })
        // 地理编码,返回地理编码结果
        geocoder.getLocation(data, (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            _this.geocoder_CallBack(result)
          }
        })
      })
    },
    addMarker (i, d) {
      const _this = this
      let marker = new AMap.Marker({
        map: _this.map,
        position: [d.location.getLng(), d.location.getLat()]
      })
      let infoWindow = new AMap.InfoWindow({
        content: d.formattedAddress,
        offset: {x: 0, y: -30}
      })
      marker.on('mouseover', (e) => {
        infoWindow.open(_this.map, marker.getPosition())
      })
    },
    // 地理编码返回结果展示
    geocoder_CallBack (data) {
      // 地理编码结果数组
      var geocode = data.geocodes
      for (var i = 0; i < geocode.length; i++) {
        this.addMarker(i, geocode[i])
      }
      this.map.setFitView()
    }
  }
}
</script>

<style lang="sass" scoped="scoped">
#map
  width: 100%
  height: 300px
</style>



// WEBPACK FOOTER //
// index.vue?33b612ea